import { React, useState, useEffect, createContext, useMemo, useRef } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const DetalleCotizacionModal = ({ open, onClose, folio }) => {
    const [titulo, setTitulo] = useState("DETALLE DE COTIZACION");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [detalle, setDetalle] = useState();

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        setTitulo(folio)
        request
            .get(
                `Cotizaciones/CotizacionesDetalle?folio=${folio}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setDetalle(result);

                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
        setLoader({ ...loader, mostrar: false });
    }, [folio, open]);

    const convertirJSON = (jsonString) => {
        try {
            const caracteristicas = JSON.parse(jsonString);
            return caracteristicas.map((c, i) => (
                <span key={i}>
                    {c.descripcion}
                    <br />
                </span>
            ));
        } catch (err) {
            return <span>-</span>; // Por si el JSON no es válido
        }
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="detalle-cotizacion-modal-formulario">
                    <div className="detalle-cotizacion-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={titulo}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`detalle-cotizacion-modal`}>
                                    <div className="detalle-cotizacion-modal-container">
                                        <div className="detalle-cotizacion-modal-table">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Modelo</th>
                                                        <th><div>Descripcion</div></th>
                                                        <th><div>Caracteristicas</div></th>
                                                        <th><div>Precio</div></th>
                                                        <th><div>Descuento</div></th>
                                                        <th><div>Precio Final</div></th>
                                                        <th><div>Moneda</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {detalle && (

                                                        detalle.map((dt) => (
                                                            <tr>
                                                                <td className="">{dt.modelo}</td>
                                                                <td>{dt.mdl_descripcion ? capitalizePalabras(dt.mdl_descripcion) : '-'}</td>
                                                                <td>{dt.caracteristicas ? convertirJSON(capitalizePalabras(dt.caracteristicas)) : '-'}</td>
                                                                <td className="ta-right">{dt.precio_lista ? FormatMoney(dt.precio_lista) : '-'}</td>
                                                                <td className="ta-right">{dt.descuento ? FormatMoney(dt.descuento) : '-'}</td>
                                                                <td className="ta-right">{dt.precio_final ? FormatMoney(dt.precio_final) : '-'}</td>
                                                                <td className="ta-center">{dt.moneda ? dt.moneda : '-'}</td>
                                                            </tr>
                                                        ))

                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {detalle && (
                                            <div className="totales-section">
                                                <div><strong>Subtotal:</strong> $ {FormatMoney(detalle.reduce((acc, dt) => acc + (dt.precio_lista || 0), 0))}</div>
                                                <div><strong>Descuentos:</strong> $ {FormatMoney(detalle.reduce((acc, dt) => acc + (dt.descuento || 0), 0))}</div>
                                                <div><strong>Total:</strong> $ {FormatMoney(detalle.reduce((acc, dt) => acc + (dt.precio_final || 0), 0))}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};